import React from "react";
import {Card, Image} from "react-bootstrap";

const Relic = (props) => {

    function importAll(r) {
        let images = {};
        r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
        return images;
    }
    
    const images = importAll(require.context('../assets/images/all', false, /\.(png|jpe?g|svg)$/));
    const backgrounds = importAll(require.context('../assets/images/relic background', false, /\.(png|jpe?g|svg)$/));
    
    const determineLevel = (relic) => {
        if (['SS', 'R1', 'R2', 'R3'].includes(relic.level))
        {
            return 'SS';
        }
        
        if (relic.level !== undefined)
        {
            return relic.level;
        }

        return relic.stats.hasOwnProperty('SS') ? 'SS' : Object.keys(relic.stats)[0];
    };

    const determineR = (relic) => {
        if ('R1' === relic.level)
        {
            return (
                <>
                    <Image className="relic-r1" src={backgrounds['jade.png']}/>
                </>
            )
        }

        else if ('R2' === relic.level)
        {
            return (
                <>
                    <Image className="relic-r1" src={backgrounds['jade.png']}/>
                    <Image className="relic-r2" src={backgrounds['jade.png']}/>
                </>
            )
        }
        else if ('R3' === relic.level)
        {
            return (
                <>
                    <Image className="relic-r1" src={backgrounds['jade.png']}/>
                    <Image className="relic-r2" src={backgrounds['jade.png']}/>
                    <Image className="relic-r3" src={backgrounds['jade.png']}/>
                </>
            )
        }
        return <></>;
    };

    return (
        <Card className={props.relic ? "relic m-1 border-0" : "relic m-1"}>
            {
                props.relic ?
                <>
                    <Image className="relic-bg" src={backgrounds[determineLevel(props.relic) + '.png']}/>
                    <Image className="relic-frame" src={backgrounds[determineLevel(props.relic) + '-Relic Frame.png']}/>
                    <Image className="relic-img" src={images[props.relic.label + '.png']} alt={props.relic.label}/>
                    {determineR(props.relic)}
                </>
                :
                <></>
            }
        </Card>
    );
};

export default Relic;